<template>
  <div class="modal-form-container" style="width: 100%; height: 100%; max-width: 100%">
    <div ref="modalContent" class="w-full h-full">
      <header class="border-b modal-form-container-header border-line">
        <h1 class="flex items-center modal-form-container-header-title">개인정보 처리방침</h1>
        <div>
          <button @click="onClose"><i class="fi fi-rr-cross"></i></button>
        </div>
      </header>

      <div class="overflow-auto modal-form-container-content" style="height: calc(100% - 4rem)">
        <pre
          class="whitespace-pre-wrap"
        >주식회사 하이쓰리디(이하 “회사”라 한다)는 개인정보 보호법 제30조에 따라 정보주체(고객)의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리지침을 수립•공개합니다. 


<b>제1조 (개인정보의 처리목적)</b>

    “회사”는 다음의 목적을 위하여 개인정보를 처리하고 있으며, 다음의 목적 이외의 용도로는 이용하지 않습니다. 

    - 고객 가입의사 확인, 고객에 대한 서비스 제공에 따른 본인 식별•인증, 회원자격 유지•관리, 물품 또는 서비스 공급에 따른 금액 결제, 물품 또는 서비스의 안내•공급•배송 등
    - 모바일 어플리케이션 이용자의 경우 영상정보 미리보기를 위한 “카메라 프리뷰 및 촬영” 기능, 사진 저장 및 공유 기능을 위한 “외부 저장소의 읽기/쓰기”기능 등


<b>제2조 (개인정보의 처리 및 보유기간)</b>

    ① “회사”는 정보주체로부터 개인정보를 수집할 때 동의받은 개인정보 보유•이용기간 또는 법령에 따른 개인정보 보유•이용기간 내에서 개인정보를 처리•보유합니다. 

    ② 구체적인 개인정보 처리 및 보유 기간은 다음과 같습니다. 
    - 고객 가입 및 관리 : 서비스 이용계약 또는 회원가입 해지시까지, 다만 채권•채무관계 잔존시에는 해당 채권•채무관계 정산시까지 
    - 전자상거래에서의 계약•청약철회, 대금결제, 재화 등 공급기록 : 5년 


<b>제3조 (개인정보의 제3자 제공)</b>

    “회사”는 정보주체의 별도 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조에 해당하는 경우 외에는 개인정보를 제3자에게 제공하지 않습니다. 


<b>제4조 (개인정보처리의 위탁)</b>

    “회사”는 원활한 서비스 제공과 업무처리를 위하여 필요한 경우 이용자의 동의 등 법률상의 요건을 구비하여 이용자의 개인정보를 외부에 위탁하여 처리할 수 있습니다. 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있으며, 공유하는 정보는 당해 목적을 달성하기 위하여 필요한 최소한의 정보에 국한됩니다. 

    1. 위탁받는 자 : 우체국 택배 등 배송업체 (위탁업무 : 상품배송)
    2. 위탁받는 자 : 리눅스웨어 (위탁업무 : 홈페이지 유지•보수)
    3. 위탁받는 자 : 유디아이디 (위탁업무 : 서비스 결제)


<b>제5조 (정보주체와 법정대리인의 권리•의무 및 행사방법)</b>

    정보주체는 “회사”에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다. 
    1. 개인정보 열람요구
    2. 개인정보에 오류 등이 있을 경우 정정 요구 
    3. 삭제요구 
    4. 처리정지 요구  


<b>제6조 (처리하는 개인정보 항목)</b>

    “회사”는 다음의 개인정보 항목을 처리하고 있습니다. 

    ① 서비스 이용자
        - 필수항목 : 성명, 전화번호, 소속, 전자메일주소, 배송주소, 문의제품 정보 등
        - 선택항목 : 성별, 생년월일, 신용카드번호, 은행계좌번호 등 결제정보
    ② 어플리케이션 이용자
        - 추가항목 : android.permission.CAMERA
        카메라 : 이 응용 프로그램은 휴대폰 단말기의 “카메라”를 사용하여 “카메라 프리뷰 또는 카메라 촬영”기능을 사용합니다. 따라서, 이 앱에 기기의 카메라 사용 권한을 부여합니다
        - 추가항목 : android.permission. WRITE_EXTERNAL_STORAGE
        저장권한 : 이 응용 프로그램의 사진 촬영기능을 바탕으로 화면을 캡쳐 하여, 저장하기 위해 저장권한을 부여합니다.
        - 추가항목 : android.permission. READ_EXTERNAL_STORAGE
        읽기권한 : 이 응용프로램으로 저장한 사진을 공유하기 위한 읽기 권한을 부여합니다.


<b>제7조 (개인정보의 파기)</b>

    ① “회사”는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다. 

    ② “회사”는 다음의 방법으로 개인정보를 파기합니다. 

        1. 전자적 파일 : 파일 삭제 및 디스크 등 저장매체 포맷
        2. 수기(手記) 문서 : 분쇄하거나 소각 
        

<b>제8조 (개인정보의 안전성 확보조치)</b>

    “회사”는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다. 

    - 관리적 조치 : 내부관리계획 수립•시행, 직원•종업원 등에 대한 정기적 교육 
    - 기술적 조치 : 개인정보처리시스템(또는 개인정보가 저장된 컴퓨터)의 비밀번호 설정 등 접근권한 관리, 백신소프트웨어 등 보안프로그램 설치, 개인정보가 저장된 파일의 암호화 
    - 물리적 조치 : 개인정보가 저장•보관된 장소의 시건, 출입통제 등 


<b>제9조 (개인정보 자동 수집 장치의 설치∙운영 및 거부에 관한 사항)</b>

    ① “회사”는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠기(cookie)’를 사용합니다.

    ② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.

        가. 쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.
        나. 쿠키의 설치∙운영 및 거부 : 웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.
        다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.


<b>제10조 (개인정보 보호책임자)</b>

    “회사”는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제를 처리하기 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다. 

    - 개인정보 보호책임자 
        성명 : 이준호          직책 : 경영지원팀장 
        연락처 : 031-436-8029


부칙 〈2020.03.26.〉
    ① 이 방침은 2020.03.26.부터 시행합니다. 
    ② 종전의 방침은 본 방침으로 대체합니다.

부칙 〈2018.07.31.〉
    ① 이 방침은 2018.08.01.부터 시행합니다. </pre>
      </div>
    </div>
  </div>
</template>

<script setup>
import {CommonStore} from "../../store/common-store";

const onClose = () => {
  CommonStore().closeTermPolicyModal();
};
</script>
